import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { LayerService } from '../../../../services/layer.service';
import { Layer } from '../../../../models/layer.models';
import { ToastNotificationService } from '../../../../services/toast-notification.service';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'frmg-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss'],
  imports: [MatCheckbox, MatButton, TranslateModule]
})
export class DownloadDialogComponent {
  public areaList: any[];
  public lineList: any[];
  public pointList: any[];
  public defaultTile: string = 'assets/images/thumbs/layer-tile.jpg';

  public selectedLayers: string[] = [];
  public isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      area_selection: any[],
      layerList: Array<Layer> & { selected: boolean }
    },
    private layerService: LayerService,
    private toastNotificationService: ToastNotificationService
  ) {
  }
  public getThumbImage(name: string) {
    return `assets/images/layers-thumbs/${name}.png`;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public layerSelected($event: MatCheckboxChange, layer: Layer) {
    if ($event.checked) {
      this.selectedLayers.push(layer.layer.id);
    } else {
      const index = this.selectedLayers.indexOf(layer.layer.id);
      this.selectedLayers.splice(index, 1);
    }
  }

  public goToDownloads() {
    this.isLoading = true;

    this.layerService.generateLayers().subscribe(_ => {
      this.isLoading = false;
      this.toastNotificationService.showNotification({ message: 'Request to download was successfully submitted', type: 'success' });
      this.dialogRef.close();
    }, error => {
      this.isLoading = false;
      let message = 'Oops, something went wrong';
      if (error.error.invalid_areas && error.error.invalid_areas.length) {
        message = '';
        error.error.invalid_areas.forEach(((err, index) => {
          if (index !== 0) message += '<br> ';
          message += err.error;
        }));
      }
      if (error.error.limit && error.error.limit.length) {
        message = '';
        error.error.limit.forEach(((_, index) => {
          if (index !== 0) message += '<br> ';
        }));
      }
      this.toastNotificationService.showNotification({ message, type: 'error' });
    });
  }
}
